import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Home from './components/Home';
import Etapa1 from './components/Etapa1';
import Etapa2 from './components/Etapa2';
import Etapa3 from './components/Etapa3';
import Etapa4 from './components/Etapa4';
import Etapa5 from './components/Etapa5';
import Etapa6 from './components/Etapa6';
import Etapa7 from './components/Etapa7';
import Admin from './components/Admin';



const Routes = () => {
    return (
        <div>
        <div className="content-container">
            <div className="blur">
                <Switch>
                    <Route path='/' exact component={Home}/>
                    <Route path='/1' exact component={Etapa1}/>
                    <Route path='/2' exact component={Etapa2}/>
                    <Route path='/3' exact component={Etapa3}/>
                    <Route path='/4' exact component={Etapa4}/>
                    <Route path='/5' exact component={Etapa5}/>
                    <Route path='/6' exact component={Etapa6}/>
                    <Route path='/7' exact component={Etapa7}/>
                    <Route path='/admin' exact component={Admin}/>
                </Switch>
            </div>
        </div>
        
        </div>
    )
}

export default Routes;